import { institutionsConstants } from "../constants/action.constants";

const initialState = {
  fetching: false,
  fetched: false,
  response: null,
  error: null
};

export const institutions = (state = initialState, action) => {
  switch (action.type) {
    case institutionsConstants.GET_INSTITUTIONS_REQUEST:
      return {
        ...state,
        fetching: true
      };
    case institutionsConstants.GET_INSTITUTIONS_SUCCESS:
      return {
        ...state,
        fetching: false,
        fetched: true,
        response: action.response,
        error: null
      };
    case institutionsConstants.GET_INSTITUTIONS_FAILURE:
      return {
        ...state,
        fetching: false,
        fetched: false,
        error: action.error
      };
    case institutionsConstants.GET_INSTITUTIONS_RESET:
      return {
        ...state,
        ...initialState
      };
    default:
      return state;
  }
};
